import { Icon } from "@iconify/react";
import { Button } from "@/shared/components/button";
import { cn } from "@/shared/lib/utils";

interface PageBackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  className?: string;
}

export function PageBackButton({ onClick, ariaLabel = "Go back", className }: PageBackButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={cn(
        "!flex !h-9 !w-9 !shrink-0 !items-center !justify-center !rounded-xl !border-0 !bg-[#F27F95] !p-0 !shadow-none hover:!bg-[#EF667F]",
        className,
      )}
    >
      <Icon icon="lucide:corner-up-left" className="h-[18px] w-[18px] !text-white" />
    </Button>
  );
}
